var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.3488L1.27604 14.0728C1.5261 13.8228 1.66662 13.4837 1.6667 13.1301V12.234C1.66677 11.8804 1.80729 11.5412 2.05736 11.2912L7.66659 5.68141M1.27604 14.0728C1.52602 13.8227 1.8651 13.6822 2.21869 13.6821H3.11467C3.46826 13.682 3.80733 13.5415 4.05732 13.2914L9.66655 7.68158M11.6664 5.6813L11.933 5.94799C12.0643 6.07932 12.1685 6.23524 12.2396 6.40683C12.3107 6.57843 12.3472 6.76234 12.3472 6.94807C12.3472 7.13381 12.3107 7.31772 12.2396 7.48932C12.1685 7.66091 12.0643 7.81683 11.933 7.94816C11.8017 8.0795 11.6458 8.18368 11.4742 8.25475C11.3027 8.32583 11.1188 8.36241 10.933 8.36241C10.7473 8.36241 10.5634 8.32583 10.3919 8.25475C10.2203 8.18368 10.0644 8.0795 9.93306 7.94816L7.39978 5.41461C7.13456 5.14937 6.98557 4.78962 6.98557 4.41452C6.98557 4.22878 7.02215 4.04487 7.09322 3.87327C7.16429 3.70168 7.26846 3.54576 7.39978 3.41443C7.5311 3.28309 7.687 3.17891 7.85857 3.10784C8.03015 3.03676 8.21404 3.00018 8.39976 3.00018C8.77482 3.00018 9.13453 3.14919 9.39974 3.41443L9.6664 3.68112L11.933 1.41425C12.1982 1.14901 12.5579 1 12.933 1C13.3081 1 13.6678 1.14901 13.933 1.41425C14.1982 1.67949 14.3472 2.03923 14.3472 2.41434C14.3472 2.78945 14.1982 3.14919 13.933 3.41443L11.6664 5.6813Z",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorAnalysis);
export default __webpack_public_path__ + "static/media/color-analysis.c429b6d8cbaf46fc546ab675117b10bf.svg";
export { ForwardRef as ReactComponent };